import { DashboardLayout } from "@/components/dashboard/dashboard-layout";
import ArchivedBidList from "./ArchivedBidList";

export default function ArchivedBidsPage() {
  return (
    <DashboardLayout activeTab="bids">
      <ArchivedBidList />
    </DashboardLayout>
  );
}
